import { render, staticRenderFns } from "./LocationsOverview.vue?vue&type=template&id=dd1c36c8&scoped=true&"
import script from "./LocationsOverview.vue?vue&type=script&lang=js&"
export * from "./LocationsOverview.vue?vue&type=script&lang=js&"
import style0 from "./LocationsOverview.vue?vue&type=style&index=0&id=dd1c36c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd1c36c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/advtool/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd1c36c8')) {
      api.createRecord('dd1c36c8', component.options)
    } else {
      api.reload('dd1c36c8', component.options)
    }
    module.hot.accept("./LocationsOverview.vue?vue&type=template&id=dd1c36c8&scoped=true&", function () {
      api.rerender('dd1c36c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/LocationsOverview.vue"
export default component.exports